import React from 'react';
import PropTypes from 'prop-types';

import Tab from '../../../components/Tab';
import Menu from '../../../components/Menu';
import HasRole from '../../../components/HasRole';
import messages from '../messages';
import PremiumMenuItem from '../Edit/PremiumMenu/premiumMenuItem';

import * as constants from '../../Authorization/constants';
import '../styles.css';

const IntroMenu = ({ toggleUpgradeFormVisibility, onShowEditAboutUsModal }) => (
  <Tab.Pane attached={false}>
    <Menu vertical styleName="editor-menu">
      <HasRole anyOf={[constants.ADMIN_ROLE, constants.PUBLISHING_ROLE]}>
        <PremiumMenuItem
          onPremiumFeatureClick={toggleUpgradeFormVisibility}
          menuTitle={messages.aboutUs}
          onClick={onShowEditAboutUsModal}
        />
      </HasRole>
    </Menu>
  </Tab.Pane>
);

IntroMenu.propTypes = {
  toggleUpgradeFormVisibility: PropTypes.func,
  onShowEditAboutUsModal: PropTypes.func,
};

export default IntroMenu;
